import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Drawer } from '@root/shared/ui-kit'

import { UploadPremiumBannerContent } from '../common/update-banner-content'

import type { PairModel } from '@root/entities/pair'
import type { DrawerProps } from '@root/shared/ui-kit'

type Props = Pick<DrawerProps, 'open' | 'onOpenChange'> & {
  pair: PairModel
}

export const UploadPremiumBannerDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
  pair,
}) => {
  const { t } = useTranslation()

  const handleClose = () => onOpenChange?.(false)

  return (
    <Root
      title={t('premium.update-logo.title')}
      open={open}
      onOpenChange={onOpenChange}
    >
      <UploadPremiumBannerContent
        pair={pair}
        open={open}
        onClose={handleClose}
      />
    </Root>
  )
}

const Root = styled(Drawer)``
